export default (text) => {
  navigator.clipboard.writeText(text)
}
